import PropTypes from "prop-types";

import { Link } from "react-router-dom";
import react, { useState, useEffect, useContext } from "react";
import AppContext from "../AppContext";
import { useHistory } from "react-router-dom";
import {
  FaCarAlt,
  FaCartPlus,
  FaShoppingCart,
  FaMoneyBillWave,
  FaTasks,
} from "react-icons/fa";
import { PulseLoader } from "react-spinners";
import { URL, SUCCESS_RESULT, ENDPOINTS } from "../Constants";
import { PERMS } from '../pages/config/perms'
import ability from '../pages/config/defineAbility';
import { searchCardHistoryApi, genericPost } from "../services/Api";
import cogoToast from "cogo-toast";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Spinner } from "reactstrap";
// import { createAbilityFor } from "../pages/config/defineAbility";


// import { Can } from "../pages/auth/config/Can";
// const abilityA = require('../pages/config/defineAbility');


const Header = ({ title, onAdd, showForm }) => {
  // const ability=abilityA.createAbilityFor();
  // const ability = createAbilityFor();

  const history = useHistory();
  
  // Search Card modal states
  const [showSearchCardModal, setShowSearchCardModal] = useState(false);
  const [cardLabel, setCardLabel] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showPhoneSearchModal, setShowPhoneSearchModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneSearchData, setPhoneSearchData] = useState(null);
  const [isPhoneSearching, setIsPhoneSearching] = useState(false);

  // Handle card search
  const handleSearchCard = () => {
    if (!cardLabel.trim()) {
      cogoToast.error("Please enter a card label", {});
      return;
    }

    setIsSearching(true);
    searchCardHistoryApi({ card_label: cardLabel.trim() })
      .then((res) => {
        setIsSearching(false);
        if (res.status === 200) {
          if (res.data.status === SUCCESS_RESULT) {
            setSearchResults(res.data.data || []);
            if (res.data.data && res.data.data.length === 0) {
              cogoToast.info("No results found for this card label", {});
            } else {
              cogoToast.success(`Found ${res.data.data.length} result(s)`, {});
            }
          } else {
            cogoToast.error(res.data.message || "Failed to search card", {});
            setSearchResults([]);
          }
        } else {
          cogoToast.error("Failed to search card", {});
          setSearchResults([]);
        }
      })
      .catch((err) => {
        setIsSearching(false);
        console.error("Error searching card:", err);
        cogoToast.error("Something went wrong while searching card", {});
        setSearchResults([]);
      });
  };

  const handleSearchBeneficiaryByPhone = () => {
    if (!phoneNumber.trim()) {
      cogoToast.error("Please enter a phone number", {});
      return;
    }

    setIsPhoneSearching(true);
    genericPost(ENDPOINTS.GET_BENEFICIARY_BY_TELEPHONE, {
      telephone: phoneNumber.trim(),
    })
      .then((res) => {
        setIsPhoneSearching(false);
        if (res.status === 200 && res.data.status === SUCCESS_RESULT) {
          setPhoneSearchData(res.data.data || null);
          const rows = res.data?.data?.enrollment_details || [];
          if (!rows.length) {
            cogoToast.info("No enrollments found for this phone", {});
          }
        } else {
          setPhoneSearchData(null);
          cogoToast.error(res?.data?.message || "Search failed", {});
        }
      })
      .catch((err) => {
        setIsPhoneSearching(false);
        setPhoneSearchData(null);
        console.error("Phone search error:", err);
        cogoToast.error("Something went wrong while searching", {});
      });
  };

  const global = useContext(AppContext);

  const [pending, setPending] = useState("");
  const [unfinished, setUnfinished] = useState("");
  const [completed, setCompleted] = useState("");
  const [unfixable, setUnfixable] = useState("");

  const [task_count, setTask_count] = useState(0);

  const [collectable_installments, setCollectable_installments] = useState([]);

  const [is_work_counts_loading, setIs_work_counts_loading] = useState(false);
  const [
    is_collectable_installments_loading,
    setIs_collectable_installments_loading,
  ] = useState(false);
  const [is_task_counts_loading, setIs_task_counts_loading] = useState(false);

  const [user, setUser] = useState({});
  useEffect(() => {
    //alert(global.get_company_info()?.code);

    let _user = global.get_logged_in_user();
    if (_user) {
      setUser(_user);
     } else {
    }
  }, []);
  const getImageMimeType = (base64Str) => {
    if (!base64Str || typeof base64Str !== "string") {
      return null; // safety check
    }

    if (base64Str.startsWith("iVBORw0KGgo")) {
      return "image/png"; // PNG type
    }

    if (base64Str.startsWith("/9j/")) {
      return "image/jpeg"; // JPEG type
    }

    return "image/jpeg"; // Default to JPEG
  };

  return (
    <div className="sticky-top">
      {" "}
      <header className="navbar navbar-expand-md navbar-light d-print-none top-border">
        <div className="container-xl">
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbar-menu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <h1 className="navbar-brand navbar-brand-autodark d-none-navbar-horizontal pe-0 pe-md-3">
            <a href="/">

              <img
                src="/images/irs_logo.png"
                alt=" "
                className="navbar-brand-imagex"
                style={{ width: 200 }}
              />
            </a>
          </h1>

          <div className="navbar-nav flex-row order-md-last">
            <div className="nav-item dropdown">
              <a
                href="#"
                className="nav-link d-flex lh-1 text-reset p-0"
                data-bs-toggle="dropdown"
                aria-label="Open user menu"
              >
                <span
                  className="avatar avatar-lg"
                  style={{
                    backgroundImage: `url(${user.photo || 'https://firebasestorage.googleapis.com/v0/b/ims-code.appspot.com/o/user.svg?alt=media&token=0cba14fd-d1a3-49ee-8a27-abf6bb368017'})`,
                  }}
                ></span>

                <div className="  d-xl-block ps-2 ">
                  <div style={{ color: "black", fontWeight: "bold" }}>
                    {" "}
                    {user.name}
                  </div>
                  <div className="mt-1 small text-muted">

                    <span className="badge-success">{user.role_name ?? "User"}</span>
                  </div>
                  <div className="mt-1 small text-muted">
                    {URL.includes("staging") && (
                      <span className="badge-success">Staging</span>
                    )}
                  </div>
                </div>
              </a>
              <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                {/* <a href="/user/profile" className="dropdown-item">
                  Profile &amp; Account
                </a> */}
                {(ability.can(PERMS.UPDATE, PERMS.MANAGE_ACCESS) && user?.role=="999") && (
                  <a href="/ebms/access-rights" className="dropdown-item">
                    Manage Access
                  </a>
                )}

 

                {(ability.can(PERMS.UPDATE, PERMS.MANAGE_PERMISSIONS) && user?.role=="999") && (
                  <a href="/ebms/manage-permissions" className="dropdown-item">
                    Permissions
                  </a>
                )}




                {ability.can(PERMS.UPDATE, PERMS.UPDATE_TEMPLATES) && (
                  <a href="/ebms/template-configurations" className="dropdown-item">
              Location Template
                  </a>
                )}

                {ability.can(PERMS.READ, PERMS.MANAGE_USERS) && (<a
                  href="/users/list"
                  className="dropdown-item"
                >
                  User Management
                </a>)}

                {ability.can(PERMS.READ, PERMS.MANAGE_USERS) && (
                  <a href="/admin/audit-logs" className="dropdown-item">
                    Audit Logs
                  </a>
                )}

                {ability.can(PERMS.READ, PERMS.MANAGE_USERS) && (
                  <a href="/admin/system-notifications" className="dropdown-item">
                    System Notifications
                  </a>
                )}

                {ability.can(PERMS.READ, PERMS.MANAGE_USERS) && (
                  <a href="/admin/settings" className="dropdown-item">
                    Settings
                  </a>
                )}


                {ability.can(PERMS.CREATE, PERMS.MANAGE_WORKFLOWS) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  // pathname: "/ebms/surveys/web-survey/:id",
                                  pathname: "/workflows",
                                }}
                                onClick={() => { }}
                              >
                                List Workflows
                              </Link>
                            )}


                            {ability.can(PERMS.CREATE, PERMS.MANAGE_WORKFLOWS) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/workflows/levels",
                                }}

                              >
                                Workflow Levels
                              </Link>
                            )}

                <a
                  href="#"
                  className="dropdown-item"
                  onClick={() => global.logout()}
                >
                  Logout
                </a>
              </div>
            </div>
          </div>
          <div className="collapse navbar-collapse" id="navbar-menu">
            <div className="d-flex flex-column flex-md-row flex-fill align-items-stretch align-items-md-center">
              <ul className="navbar-nav">
                <li className="nav-item ">
                  <Link
                    to={{
                      pathname: "/",
                    }}
                    className="nav-link"
                  >
                    <span className="nav-link-icon d-md-none d-lg-inline-block">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="icon"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <polyline points="5 12 3 12 12 3 21 12 19 12"></polyline>
                        <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                        <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
                      </svg>
                    </span>
                    <span className="nav-link-title">Home</span>
                  </Link>
                </li>

                <>

                  {ability.can(PERMS.READ, PERMS.HRM) && (
                    <li className="nav-item">
                      <Link
                        className="nav-link"
                        to={{
                          pathname: "/hrm",
                        }}
                      >
                        <span className="nav-link-title">HRM</span>
                      </Link>
                    </li>
                  )}









                  {ability.can(PERMS.READ, PERMS.ASSET) && (

                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#navbar-base"
                        data-bs-toggle="dropdown"
                        role="button"
                        aria-expanded="false"
                      >
                        <span className="nav-link-icon d-md-none d-lg-inline-block">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
                            <line x1="12" y1="12" x2="20" y2="7.5" />
                            <line x1="12" y1="12" x2="12" y2="21" />
                            <line x1="12" y1="12" x2="4" y2="7.5" />
                            <line x1="16" y1="5.25" x2="8" y2="9.75" />
                          </svg>
                        </span>
                        <span className="nav-link-title">ASSET</span>
                      </a>

                      <div className="dropdown-menu">
                        <div className="dropdown-menu-columns">
                          <div className="dropdown-menu-column">
                            {ability.can(PERMS.READ, PERMS.LIST_ASSETS) && (

                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/asset/asset-list",
                                }}
                              >
                                Asset Listing
                              </Link>)}
                              
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/asset/cards-summary",
                                }}
                              >
                                EBMS Cards Inventory
                              </Link>

                              

                            {ability.can(PERMS.READ, PERMS.LIST_ASSET_CATEGORIES) && (

                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/asset/category-list",
                                }}
                              >
                                Asset Categories
                              </Link>)}
                              {/* {ability.can(PERMS.READ, PERMS.LIST_ASSETS) && (
                                <Link
                                  className="dropdown-item"
                                  to={{
                                    pathname: "/asset/card-list",
                                  }}
                                >
                                  Card Management
                                </Link>
                              )} */}
                            
                          </div>
                        </div>
                      </div>


                    </li>)}


                  {(ability.can(PERMS.READ, PERMS.PROJECTS) || ability.can(PERMS.READ, PERMS.LIST_PROJECTS) || ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT)) && (
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#navbar-base"
                        data-bs-toggle="dropdown"
                        role="button"
                        aria-expanded="false"
                      >
                        <span className="nav-link-icon d-md-none d-lg-inline-block">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
                            <line x1="12" y1="12" x2="20" y2="7.5" />
                            <line x1="12" y1="12" x2="12" y2="21" />
                            <line x1="12" y1="12" x2="4" y2="7.5" />
                            <line x1="16" y1="5.25" x2="8" y2="9.75" />
                          </svg>
                        </span>
                        <span className="nav-link-title">PROJECTS</span>
                      </a>

                      <div className="dropdown-menu">
                        <div className="dropdown-menu-columns">
                          <div className="dropdown-menu-column">
                            {ability.can(PERMS.READ, PERMS.LIST_PROJECTS) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/list",
                                }}
                              >
                                Project Listing
                              </Link>)}


                            {ability.can(PERMS.CREATE, PERMS.CREATE_PROJECT) && (

                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/create",
                                }}
                              >
                                Create Project
                              </Link>)}
                            {ability.can(PERMS.READ, PERMS.LIST_WASH_PROJECTS) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/wash",
                                }}
                              >
                                WASH Projects
                              </Link>
                            )}
                            {ability.can(PERMS.READ, PERMS.LIST_WASH_PROJECTS) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/wash/dashboard",
                                }}
                              >
                                WASH Dashboard
                              </Link>
                            )}
                            {ability.can(PERMS.CREATE, PERMS.CREATE_WASH_PROJECT) ||
                            ability.can(PERMS.READ, PERMS.LIST_WASH_PROJECTS) ? (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/wash/create",
                                }}
                              >
                                Create Wash Project Entry
                              </Link>
                            ) : null}
                            {ability.can(PERMS.CREATE, PERMS.CREATE_WASH_PROJECT) ||
                            ability.can(PERMS.READ, PERMS.LIST_WASH_PROJECTS) ? (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/wash/upload",
                                }}
                              >
                                Upload Wash Projects From Excel
                              </Link>
                            ) : null}
                            {ability.can(PERMS.CREATE, PERMS.CAN_CLONE_BENEFICIARIES) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/clone-beneficiaries",
                                }}
                              >
                                Clone Beneficiaries
                              </Link>
                            )}
                            {ability.can(PERMS.READ, PERMS.CAN_VIEW_PROJECT_MAPPING_LISTING) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/erp-project-mapping",
                                }}
                              >
                                ERP Project Mapping
                              </Link>
                            )}
                            {ability.can(PERMS.READ, PERMS.CAN_UPLOAD_PROJECT_MAPPINGS) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/projects/upload-project-mappings",
                                }}
                              >
                                Upload Project Mappings
                              </Link>
                            )}
                            {ability.can(PERMS.CREATE, PERMS.CAN_UPLOAD_BENEFICIARY_RECORDS) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/admin/upload-bnf",
                                }}
                              >
                                Upload Beneficiary Records
                              </Link>
                            )}
                            {ability.can(PERMS.CREATE, PERMS.CAN_UPLOAD_CVA_RECORDS) && (
                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/admin/upload-cva",
                                }}
                              >
                                Upload CVA Records
                              </Link>
                            )}
                            <div className="dropdown-divider"></div>
                            
                            {/* Search Card - Permission required */}
                            {ability.can(PERMS.READ, PERMS.CAN_VIEW_CARD_HISTORY) && (
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowSearchCardModal(true);
                                  setCardLabel("");
                                  setSearchResults([]);
                                }}
                              >
                                Search Card
                              </a>
                            )}
                            {ability.can(PERMS.READ, PERMS.CAN_SEARCH_BENEFICIARY_BY_TELEPHONE) && (
                              <a
                                className="dropdown-item"
                                href="#"
                                onClick={(e) => {
                                  e.preventDefault();
                                  setShowPhoneSearchModal(true);
                                  setPhoneNumber("");
                                  setPhoneSearchData(null);
                                }}
                              >
                                Search Beneficiry by phone
                              </a>
                            )}
                          


                          







                          </div>
                        </div>
                      </div>
                    </li>
                  )}
                  {/* {ability.can(PERMS.READ, PERMS.PROJECTS) && (
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#navbar-base"
                      data-bs-toggle="dropdown"
                      role="button"
                      aria-expanded="false"
                    >
                      <span className="nav-link-icon d-md-none d-lg-inline-block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
                          <line x1="12" y1="12" x2="20" y2="7.5" />
                          <line x1="12" y1="12" x2="12" y2="21" />
                          <line x1="12" y1="12" x2="4" y2="7.5" />
                          <line x1="16" y1="5.25" x2="8" y2="9.75" />
                        </svg>
                      </span>
                      <span className="nav-link-title">PROJECTS</span>
                    </a>
                    {ability.can(PERMS.READ, PERMS.LIST_PROJECTS) && (
                    <div className="dropdown-menu">
                      <div className="dropdown-menu-columns">
                        <div className="dropdown-menu-column">
                          <Link
                            className="dropdown-item"
                            to={{
                              pathname: "/projects/list",
                            }}
                          >
                            Project Listing
                          </Link>{" "}

                        </div>
                      </div>
                    </div>)}


                  </li> 
                )} */}

                {ability.can(PERMS.READ, PERMS.HMIS) && (
                  <>
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle"
                        href="#navbar-base"
                        data-bs-toggle="dropdown"
                        role="button"
                        aria-expanded="false"
                      >
                        <span className="nav-link-icon d-md-none d-lg-inline-block">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                            stroke="currentColor"
                            fill="none"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          >
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
                            <line x1="12" y1="12" x2="20" y2="7.5" />
                            <line x1="12" y1="12" x2="12" y2="21" />
                            <line x1="12" y1="12" x2="4" y2="7.5" />
                            <line x1="16" y1="5.25" x2="8" y2="9.75" />
                          </svg>
                        </span>

                        <span className="nav-link-title">HMIS</span>
                      </a>

                      <div className="dropdown-menu">
                        <div className="dropdown-menu-columns">
                          <div className="dropdown-menu-column">
                            <Link
                              className="dropdown-item"
                              to={{
                                // pathname: "/ebms/surveys/web-survey/:id",
                                pathname: "/hmis/dashboard",
                              }}
                              onClick={() => { }}
                            >
                              HMIS DASHBOARD
                            </Link>
                       


                              
                            {ability.can(PERMS.READ, PERMS.CAN_VIEW_REDEPTION_REPORT) && (

                              <Link
                                className="dropdown-item"
                                to={{
                                  pathname: "/hmis/redemption-summary",
                                }}

                              >
                             Medicine Redemption Summary
                              </Link>)}
     
     
     {ability.can(PERMS.CREATE, PERMS.CAN_VIEW_REDEPTION_REPORT) && (

<Link
  className="dropdown-item"
  to={{
    pathname: "/hmis/redemption-report",
  }}>
 Medicine Redemption Report
</Link>)}

                         


                          </div>
                        </div>
                      </div>


                    </li>
                  </>





                )}
                {(ability.can(PERMS.READ, PERMS.SURVEYS) || ability.can(PERMS.CREATE, PERMS.CREATE_SURVEYS) || ability.can(PERMS.READ, PERMS.LIST_SURVEYS)) && (
                  <li className="nav-item dropdown">
                    <a
                      className="nav-link dropdown-toggle"
                      href="#navbar-base"
                      data-bs-toggle="dropdown"
                      role="button"
                      aria-expanded="false"
                    >
                      <span className="nav-link-icon d-md-none d-lg-inline-block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="icon"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          strokeWidth="2"
                          stroke="currentColor"
                          fill="none"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                          <polyline points="12 3 20 7.5 20 16.5 12 21 4 16.5 4 7.5 12 3" />
                          <line x1="12" y1="12" x2="20" y2="7.5" />
                          <line x1="12" y1="12" x2="12" y2="21" />
                          <line x1="12" y1="12" x2="4" y2="7.5" />
                          <line x1="16" y1="5.25" x2="8" y2="9.75" />
                        </svg>
                      </span>

                      <span className="nav-link-title">SURVEYS</span>
                    </a>

                    <div className="dropdown-menu">
                      <div className="dropdown-menu-columns">
                        <div className="dropdown-menu-column">
                          <Link
                            className="dropdown-item"
                            to={{
                              // pathname: "/ebms/surveys/web-survey/:id",
                              pathname: "/ebms/surveys/ongoing",
                            }}
                            onClick={() => { }}
                          >
                            Ongoing Surveys
                          </Link>
                          {ability.can(PERMS.CREATE, PERMS.CREATE_SURVEYS) && (

                            <Link
                              className="dropdown-item"
                              to={{
                                pathname: "/ebms/surveys/create",
                              }}
                              onClick={() => {
                                localStorage.removeItem("current_survey_id");
                                localStorage.removeItem("current_survey_name");
                              }}
                            >
                              Create new Survey
                            </Link>)}

                          {ability.can(PERMS.READ, PERMS.SURVEYS) && (
                            <Link
                              className="dropdown-item"
                              to={{
                                pathname: "/ebms/surveys/list",
                              }}
                            >
                              List Surveys
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>

 

                  </li>
                )}








                </>

              </ul>
            </div>
          </div>
        </div>
      </header>

      {/* Search Card Modal */}
      <Modal isOpen={showSearchCardModal} toggle={() => setShowSearchCardModal(false)} size="lg">
        <ModalHeader toggle={() => setShowSearchCardModal(false)}>
          Search Card History
        </ModalHeader>
        <ModalBody>
          <div className="form-group">
            <label><strong>Card Label</strong></label>
            <div className="input-group">
              <input
                type="text"
                className="form-control"
                placeholder="Enter card label (e.g., 020324060035)"
                value={cardLabel}
                onChange={(e) => setCardLabel(e.target.value)}
                onKeyPress={(e) => {
                  if (e.key === 'Enter' && cardLabel.trim()) {
                    handleSearchCard();
                  }
                }}
              />
              <div className="input-group-append">
                <Button
                  color="primary"
                  onClick={handleSearchCard}
                  disabled={isSearching || !cardLabel.trim()}
                >
                  {isSearching ? (
                    <>
                      <Spinner size="sm" className="mr-2" />
                      Searching...
                    </>
                  ) : (
                    'Search'
                  )}
                </Button>
              </div>
            </div>
          </div>

          {/* Search Results */}
          {searchResults.length > 0 && (
            <div className="mt-4">
              <h5 className="mb-3">Search Results ({searchResults.length})</h5>
              <div className="row">
                {searchResults.map((result, index) => (
                  <div key={index} className="col-12 mb-3">
                    <div className="card shadow-sm" style={{
                      border: '1px solid #e0e0e0',
                      borderRadius: '12px',
                      transition: 'transform 0.2s, box-shadow 0.2s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-3px)';
                      e.currentTarget.style.boxShadow = '0 6px 12px rgba(0,0,0,0.15)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.1)';
                    }}>
                      <div className="card-header" style={{
                        backgroundColor: result.Onboarded_status === 'Already used' ? '#fff3cd' : '#d4edda',
                        borderBottom: `3px solid ${result.Onboarded_status === 'Already used' ? '#ffc107' : '#28a745'}`,
                        borderRadius: '12px 12px 0 0',
                        padding: '12px 15px'
                      }}>
                        <div className="d-flex justify-content-between align-items-center">
                          <div style={{ flex: 1 }}>
                            <h6 className="mb-1" style={{ margin: 0, fontWeight: 'bold', color: '#155724', fontSize: '16px' }}>
                              {result.beneficiary_name || 'N/A'}
                            </h6>
                            <small style={{ color: '#155724' }}>Card ID: <strong>{result.card_id || 'N/A'}</strong></small>
                          </div>
                          <span 
                            className={`badge ${result.Onboarded_status === 'Already used' ? 'badge-warning' : 'badge-success'}`}
                            style={{ 
                              fontSize: '11px', 
                              padding: '6px 12px', 
                              fontWeight: 'bold',
                              backgroundColor: result.Onboarded_status === 'Already used' ? '#ffc107' : '#28a745',
                              color: '#fff',
                              marginLeft: '15px',
                              borderRadius: '6px',
                              whiteSpace: 'nowrap'
                            }}>
                            {result.Onboarded_status || 'N/A'}
                          </span>
                        </div>
                      </div>
                      <div className="card-body" style={{ padding: '15px' }}>
                        <div className="row">
                          {/* Left Column */}
                          <div className="col-md-6">
                            <div className="d-flex align-items-center mb-2">
                              <i className="fa fa-credit-card mr-2" style={{ color: '#007bff', width: '18px', fontSize: '14px' }}></i>
                              <div className="d-flex align-items-center" style={{ flex: 1 }}>
                                <strong style={{ fontSize: '13px', marginRight: '8px' }}>Card Label:</strong>
                                <code style={{
                                  backgroundColor: '#f8f9fa',
                                  padding: '3px 6px',
                                  borderRadius: '4px',
                                  fontSize: '13px',
                                  fontWeight: 'bold',
                                  color: '#dc3545'
                                }}>{result.card_label || 'N/A'}</code>
                              </div>
                            </div>

                            <div className="row">
                              <div className="col-6 mb-2">
                                <div className="d-flex align-items-center">
                                  <i className="fa fa-phone mr-2" style={{ color: '#28a745', width: '18px', fontSize: '13px' }}></i>
                                  <div>
                                    <small className="text-muted d-block" style={{ fontSize: '11px' }}>Telephone</small>
                                    <strong style={{ fontSize: '13px' }}>{result.telephone || 'N/A'}</strong>
                                  </div>
                                </div>
                              </div>
                              <div className="col-6 mb-2">
                                <div className="d-flex align-items-center">
                                  <i className="fa fa-birthday-cake mr-2" style={{ color: '#ff6b6b', width: '18px', fontSize: '13px' }}></i>
                                  <div>
                                    <small className="text-muted d-block" style={{ fontSize: '11px' }}>Age</small>
                                    <strong style={{ fontSize: '13px' }}>{result.age || 'N/A'}</strong>
                                  </div>
                                </div>
                              </div>
                              <div className="col-6 mb-2">
                                <div className="d-flex align-items-center">
                                  <i className="fa fa-users mr-2" style={{ color: '#17a2b8', width: '18px', fontSize: '13px' }}></i>
                                  <div>
                                    <small className="text-muted d-block" style={{ fontSize: '11px' }}>Total HH</small>
                                    <strong style={{ fontSize: '13px' }}>{result.total_hh || 'N/A'}</strong>
                                  </div>
                                </div>
                              </div>
                              <div className="col-6 mb-2">
                                <div className="d-flex align-items-center">
                                  <i className="fa fa-calendar mr-2" style={{ color: '#6c757d', width: '18px', fontSize: '13px' }}></i>
                                  <div>
                                    <small className="text-muted d-block" style={{ fontSize: '11px' }}>Onboarded At</small>
                                    <strong style={{ fontSize: '12px' }}>{result.onboarded_at || result.Onboarded_at || 'N/A'}</strong>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Right Column */}
                          <div className="col-md-6">
                            <div className="d-flex align-items-start mb-2">
                              <i className="fa fa-folder-open mr-2" style={{ color: '#007bff', width: '18px', fontSize: '13px', marginTop: '2px' }}></i>
                              <div style={{ flex: 1 }}>
                                <small className="text-muted d-block" style={{ fontSize: '11px' }}>Project</small>
                                <strong style={{ fontSize: '13px' }}>{result.project_name || 'N/A'}</strong>
                              </div>
                            </div>
                            <div className="d-flex align-items-start mb-2">
                              <i className="fa fa-tasks mr-2" style={{ color: '#6f42c1', width: '18px', fontSize: '13px', marginTop: '2px' }}></i>
                              <div style={{ flex: 1 }}>
                                <small className="text-muted d-block" style={{ fontSize: '11px' }}>Component</small>
                                <strong style={{ fontSize: '13px' }}>{result.component_name || 'N/A'}</strong>
                              </div>
                            </div>
                            {result.camp && (
                              <div className="d-flex align-items-start">
                                <i className="fa fa-map-marker-alt mr-2" style={{ color: '#dc3545', width: '18px', fontSize: '13px', marginTop: '2px' }}></i>
                                <div style={{ flex: 1 }}>
                                  <small className="text-muted d-block mb-1" style={{ fontSize: '11px' }}>Location</small>
                                  {result.camp && <div style={{ fontSize: '12px' }}><strong>Camp:</strong> {result.camp}</div>}
                                  {result.village && <div style={{ fontSize: '12px' }}><strong>Village:</strong> {result.village}</div>}
                                  {result.district && <div style={{ fontSize: '12px' }}><strong>District:</strong> {result.district}</div>}
                                  {result.region && <div style={{ fontSize: '12px' }}><strong>Region:</strong> {result.region}</div>}
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {searchResults.length === 0 && !isSearching && cardLabel && (
            <div className="alert alert-info mt-3">
              No results found for card label: <strong>{cardLabel}</strong>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => {
            setShowSearchCardModal(false);
            setCardLabel("");
            setSearchResults([]);
          }}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={showPhoneSearchModal}
        toggle={() => setShowPhoneSearchModal(false)}
        size="xl"
        modalClassName="phone-search-modal-xl"
      >
        <ModalHeader toggle={() => setShowPhoneSearchModal(false)}>
          Search Beneficiary by Telephone
        </ModalHeader>
        <ModalBody>
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              <div className="row g-2 align-items-end">
                <div className="col-md-9">
                  <label><strong>Phone Number</strong></label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter phone number (e.g. 612157162)"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === "Enter" && phoneNumber.trim()) {
                        handleSearchBeneficiaryByPhone();
                      }
                    }}
                  />
                </div>
                <div className="col-md-3">
                  <Button
                    color="primary"
                    className="w-100"
                    onClick={handleSearchBeneficiaryByPhone}
                    disabled={isPhoneSearching || !phoneNumber.trim()}
                  >
                    {isPhoneSearching ? (
                      <>
                        <Spinner size="sm" className="mr-2" /> Searching...
                      </>
                    ) : (
                      "Search"
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </div>

          {phoneSearchData && (
            <div className="card border-0 shadow-sm">
              <div className="card-body">
                <div className="d-flex flex-wrap gap-3 mb-3">
                  <span className="badge bg-primary">
                    Phone: {phoneSearchData.telephone || "-"}
                  </span>
                  <span className="badge bg-info">
                    Projects: {phoneSearchData.projects_enrolled_count || 0}
                  </span>
                  <span className="badge bg-secondary">
                    Enrollments: {phoneSearchData.enrollments_count || 0}
                  </span>
                </div>

                <div className="row g-2">
                  {(phoneSearchData.enrollment_details || []).map((item, idx) => {
                    const criteria = item?.criteria_score;
                    const hasCriteria = criteria && typeof criteria === "object";
                    const isActive = item?.status === 10001;
                    return (
                      <div key={item?.enrollment_id || idx} className="col-12 col-lg-6">
                        <div className="card h-100 border-0 shadow-sm" style={{ background: "#fbfcff" }}>
                          <div className="card-body p-2">
                            <div className="d-flex justify-content-between align-items-start mb-1">
                              <div style={{ fontSize: "12px", fontWeight: 600 }}>
                                #{idx + 1} {item?.beneficiary_name || "-"}
                              </div>
                              <span
                                className={`badge ${isActive ? "bg-success" : "bg-danger"}`}
                                style={{ fontSize: "10px" }}
                              >
                                {isActive ? "Active" : "Deactivated"}
                              </span>
                            </div>

                            <div className="text-muted mb-1" style={{ fontSize: "11px" }}>
                              {item?.telephone || "-"}
                            </div>

                            <div style={{ fontSize: "11px", lineHeight: 1.35 }}>
                              <div><strong>Project:</strong> {item?.project_name || "-"}</div>
                              <div><strong>Alias:</strong> {item?.project_alias || "-"}</div>
                              <div><strong>Component:</strong> {item?.component_name || "-"}</div>
                              <div><strong>Enrolled:</strong> {item?.enrolled_at || "-"}</div>
                              <div><strong>Registered By:</strong> {item?.registered_by?.name || "-"}</div>
                              <div><strong>Card Label:</strong> {item?.card_label || "-"}</div>
                              <div>
                                <strong>Criteria:</strong>{" "}
                                {hasCriteria
                                  ? `Score ${criteria.score ?? "-"} / Threshold ${criteria.threshold ?? "-"} / ${criteria.can_proceed ? "Pass" : "Fail"}`
                                  : "N/A"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setShowPhoneSearchModal(false);
              setPhoneNumber("");
              setPhoneSearchData(null);
            }}
          >
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <style>{`
        .phone-search-modal-xl {
          max-width: 96vw !important;
          width: 96vw !important;
        }
        .phone-search-modal-xl .modal-content {
          min-height: 80vh;
        }
      `}</style>
    </div>
  );
};

Header.defaultProps = {
  title: "ISLAMIC RELIEF",
};

Header.propTypes = {
  title: PropTypes.string.isRequired,
};

//CSS In JS
// const headingStyle = {
//   color: "black",
//   backgroundColor: "yellow",
// };

export default Header;
